<template>
  <section class="gallery-container">
    <h1>DUMP Days prošlih godina</h1>
    <div ref="sliding" class="slideable sliding">
      <div ref="gridContainer" class="grid__container">
        <div class="year-break">
          <span class="year-line" />
          <a
            class="text--underline hide-after"
            href="https://2019.days.dump.hr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            2019.
          </a>
        </div>
        <div class="grid grid-19">
          <img class="img19-1" src="../../assets/gallery/dd19/hockey.jpg" alt ondragstart="return false;" />
          <img class="img19-2" src="../../assets/gallery/dd19/workshop.jpg" alt ondragstart="return false;" />
          <img class="img19-3" src="../../assets/gallery/dd19/campfire.jpg" alt ondragstart="return false;" />
          <span class="statistic stat19-1">
            <h4>140,000</h4>
            <h4>nagradnih bodova</h4>
          </span>
          <img class="img19-4" src="../../assets/gallery/dd19/press.jpg" alt ondragstart="return false;" />
          <span class="statistic stat19-2">
            <h4>1,500</h4>
            <h4>ispaljenih strelica</h4>
          </span>
          <img class="img19-5" src="../../assets/gallery/dd19/archery.jpg" alt ondragstart="return false;" />
          <img class="img19-6" src="../../assets/gallery/dd19/lecture.jpg" alt ondragstart="return false;" />
        </div>
        <div class="year-break">
          <span class="year-line" />
          <a
            class="text--underline hide-after"
            href="https://2018.days.dump.hr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            2018.
          </a>
        </div>
        <div class="grid grid-18">
          <span class="statistic stat18-1">
            <h4>140</h4>
            <h4>jumbo pizza</h4>
          </span>
          <img class="img18-1" src="../../assets/gallery/dd18/opening.jpg" alt ondragstart="return false;" />
          <img class="img18-2" src="../../assets/gallery/dd18/darts.jpg" alt ondragstart="return false;" />
          <img class="img18-3" src="../../assets/gallery/dd18/games.jpg" alt ondragstart="return false;" />
          <img class="img18-4" src="../../assets/gallery/dd18/crossing.jpg" alt ondragstart="return false;" />
          <img class="img18-5" src="../../assets/gallery/dd18/press.jpg" alt ondragstart="return false;" />
          <span class="statistic stat18-2">
            <h4>1</h4>
            <h4>escape room</h4>
          </span>
          <img class="img18-6" src="../../assets/gallery/dd18/beer.jpg" alt ondragstart="return false;" />
        </div>
        <div class="year-break">
          <span class="year-line" />
          <a
            class="text--underline hide-after"
            href="https://2017.days.dump.hr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            2017.
          </a>
        </div>
        <div class="grid grid-17">
          <img class="img17-1" src="../../assets/gallery/dd17/games.jpg" alt ondragstart="return false;" />
          <img class="img17-2" src="../../assets/gallery/dd17/chill.jpg" alt ondragstart="return false;" />
          <img class="img17-3" src="../../assets/gallery/dd17/foosball.jpg" alt ondragstart="return false;" />
          <span class="statistic stat17-1">
            <h4>1400</h4>
            <h4>šalica kave</h4>
          </span>
          <img class="img17-4" src="../../assets/gallery/dd17/lecture.jpg" alt ondragstart="return false;" />
          <span class="statistic stat17-2">
            <h4>5</h4>
            <h4>nagrada</h4>
          </span>
          <img class="img17-5" src="../../assets/gallery/dd17/entrance.jpg" alt ondragstart="return false;" />
          <img class="img17-6" src="../../assets/gallery/dd17/selfie.jpg" alt ondragstart="return false;" />
        </div>
        <div class="year-break">
          <span class="year-line" />
          <a class="text--underline hide-after" href="https://day.dump.hr/" target="_blank" rel="noopener noreferrer">
            2016.
          </a>
        </div>
        <div class="grid grid-16">
          <span class="statistic stat16-1">
            <h4>14</h4>
            <h4>sponzora</h4>
          </span>
          <img class="img16-1" src="../../assets/gallery/dd16/atrium.jpg" alt ondragstart="return false;" />
          <img class="img16-2" src="../../assets/gallery/dd16/balloons.jpg" alt ondragstart="return false;" />
          <img class="img16-3" src="../../assets/gallery/dd16/speaker.jpg" alt ondragstart="return false;" />
          <img class="img16-4" src="../../assets/gallery/dd16/day.jpg" alt ondragstart="return false;" />
          <img class="img16-5" src="../../assets/gallery/dd16/class.jpg" alt ondragstart="return false;" />
          <span class="statistic stat16-2">
            <h4>13</h4>
            <h4>predavanja</h4>
          </span>
          <img class="img16-6" src="../../assets/gallery/dd16/lecture.jpg" alt ondragstart="return false;" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.gallery-container {
  overflow: hidden;
  padding-bottom: 100px;
}

h1 {
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  color: #ffffff;
  font-size: 40px;
  margin-top: 140px;
  margin-bottom: 80px;
  text-align: center;
  font-weight: 900;
}

.text--underline {
  transition: color 0.2s ease-in-out;
}

.text--underline:hover {
  color: #35e5d8;
}

.text--underline::after {
  display: none;
}

.year-break {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: -48px;
}

.year-break a {
  text-decoration: none;
  font-size: 24px;
  color: #30cec2;
  text-decoration: underline;
  font-weight: bold;
  transform: translate(100%, -68px);
  margin-bottom: -100px;
}

.year-line {
  margin-bottom: 64px;
  height: 100%;
  width: 2px;
  background-image: linear-gradient(to bottom, #ffffff 50%, transparent 50%);
  background-size: 2px 24px;
  position: relative;
}

.year-line::after {
  content: '';
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: #ffffff;
  position: absolute;
  bottom: -20px;
  right: -8px;
}

.statistic {
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  z-index: -1;
  position: relative;
  background: #ffffff08;
}

.statistic h4 {
  color: #fff;
  font-weight: 800;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  max-width: 80%;
  margin: 0 auto;
}

.slideable {
  cursor: grab;
  padding-top: 50px;
  margin-top: -50px;
}

.grabbing {
  cursor: grabbing;
}

.grid {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 0.3fr 1fr 1fr 0.3fr 1fr;
  gap: 50px 24px;
  justify-content: center;
}

.grid span,
.grid img {
  border-radius: 30px;
  width: 100%;
  user-select: none;
}

.img19-1 {
  grid-area: img19-1;
}

.img19-2 {
  grid-area: img19-2;
}

.img19-3 {
  grid-area: img19-3;
}

.img19-4 {
  grid-area: img19-4;
}

.img19-5 {
  grid-area: img19-5;
}

.img19-6 {
  grid-area: img19-6;
}

.stat19-1 {
  grid-area: stat19-1;
}

.stat19-2 {
  grid-area: stat19-2;
}

.img19-2,
.img19-3,
.img19-4,
.img19-6 {
  height: 100%;
}

.grid-19 {
  grid-template-areas: 'img19-1 img19-2 img19-2 img19-3 img19-3 stat19-1' 'img19-4 img19-4 stat19-2 img19-5 img19-6 img19-6';
}

.img18-1 {
  grid-area: img18-1;
}

.img18-2 {
  grid-area: img18-2;
}

.img18-3 {
  grid-area: img18-3;
}

.img18-4 {
  grid-area: img18-4;
}

.img18-5 {
  grid-area: img18-5;
}

.img18-6 {
  grid-area: img18-6;
}

.stat18-1 {
  grid-area: stat18-1;
}

.stat18-2 {
  grid-area: stat18-2;
}

.img18-1,
.img18-2,
.img18-4,
.img18-6 {
  height: 100%;
}

.grid-18 {
  grid-template-areas: 'stat18-1 img18-1 img18-1 img18-2 img18-2 img18-3 ' 'img18-4 img18-4 img18-5 stat18-2 img18-6 img18-6';
}

.img17-1 {
  grid-area: img17-1;
}

.img17-2 {
  grid-area: img17-2;
}

.img17-3 {
  grid-area: img17-3;
}

.img17-4 {
  grid-area: img17-4;
}

.img17-5 {
  grid-area: img17-5;
}

.img17-6 {
  grid-area: img17-6;
}

.stat17-1 {
  grid-area: stat17-1;
}

.stat17-2 {
  grid-area: stat17-2;
}

.img17-2,
.img17-3,
.img17-4,
.img17-6 {
  height: 100%;
}

.grid-17 {
  grid-template-areas: 'img17-1 img17-2 img17-2 img17-3 img17-3 stat17-1' 'img17-4 img17-4 stat17-2 img17-5 img17-6 img17-6';
}

.img16-1 {
  grid-area: img16-1;
}

.img16-2 {
  grid-area: img16-2;
}

.img16-3 {
  grid-area: img16-3;
}

.img16-4 {
  grid-area: img16-4;
}

.img16-5 {
  grid-area: img16-5;
}

.img16-6 {
  grid-area: img16-6;
}

.stat16-1 {
  grid-area: stat16-1;
}

.stat16-2 {
  grid-area: stat16-2;
}

.img16-1,
.img16-2,
.img16-4,
.img16-6 {
  height: 100%;
}

.grid-16 {
  grid-template-areas: 'stat16-1 img16-1 img16-1 img16-2 img16-2 img16-3 ' 'img16-4 img16-4 img16-5 stat16-2 img16-6 img16-6';
}

.grid__container {
  display: flex;
  width: 280vw;
}

@media screen and (max-width: 1440px) {
  .grid__container {
    width: 320vw;
  }
}

@media screen and (max-width: 1250px) {
  .grid__container {
    width: 420vw;
  }

  .statistic h4 {
    font-size: 26px;
    line-height: 32px;
  }

  h1 {
    font-size: 36px;
    margin-top: 140px;
    margin-bottom: 80px;
  }

  .year-break a {
    font-size: 28px;
  }

  .grid {
    gap: 42px 24px;
  }
}

@media screen and (max-width: 1100px) {
  .grid__container {
    width: 450vw;
  }
}

@media screen and (max-width: 1000px) {
  .grid__container {
    width: 480vw;
  }

  .statistic h4 {
    font-size: 22px;
    line-height: 28px;
  }

  h1 {
    font-size: 32px;
    margin-top: 140px;
    margin-bottom: 80px;
  }

  .year-break a {
    font-size: 26px;
  }

  .grid {
    gap: 36px 20px;
  }
}

@media screen and (max-width: 850px) {
  .grid__container {
    width: 500vw;
  }
}

@media screen and (max-width: 800px) {
  .grid__container {
    width: 550vw;
  }

  .statistic h4 {
    font-size: 20px;
    line-height: 28px;
  }

  h1 {
    font-size: 30px;
    margin-top: 140px;
    margin-bottom: 80px;
  }

  .year-break a {
    font-size: 24px;
  }

  .year-break a::after {
    transform: translateX(0);
  }

  .grid {
    gap: 32px 18px;
  }
}

@media screen and (max-width: 750px) {
  .grid__container {
    width: 600vw;
  }
}

@media screen and (max-width: 700px) {
  .grid__container {
    width: 650vw;
  }
}

@media screen and (max-width: 650px) {
  .grid__container {
    width: 700vw;
  }

  h1 {
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (max-width: 600px) {
  .grid__container {
    width: 720vw;
  }

  .statistic h4 {
    font-size: 18px;
    line-height: 24px;
  }

  h1 {
    font-size: 28px;
    margin-top: 140px;
    margin-bottom: 80px;
  }

  .year-break a {
    font-size: 22px;
  }

  .grid {
    gap: 26px 16px;
  }
}

@media screen and (max-width: 550px) {
  .grid__container {
    width: 750vw;
  }
}

@media screen and (max-width: 500px) {
  .grid__container {
    width: 800vw;
  }
}

@media screen and (max-width: 450px) {
  .grid__container {
    width: 850vw;
  }

  .statistic h4 {
    font-size: 16px;
    line-height: 22px;
  }

  .grid {
    gap: 20px 10px;
  }
}

@media screen and (max-width: 400px) {
  .grid__container {
    width: 900vw;
  }
}

@media screen and (max-width: 350px) {
  .grid__container {
    width: 950vw;
  }
}
</style>

<script>
export default {
  name: 'Gallery',
  data() {
    return {
      translateCount: [{ cur: 1 }, { cur: 1 }, { cur: 1 }, { cur: 1 }],
      isDown: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      elementLeftX: 0,
      pos: 0,
      gridWidth: 0,
      translateAmount: 0,
      move: 0,
      transition: '',
      intervalId: 0,
      smallTabletBreak: 768,
    };
  },
  mounted() {
    this.isDown = false;
    this.startX;
    this.startY;
    this.scrollLeft;
    this.pos = 0;

    this.initializeInfiniteScroll();
    this.initializeSliding();

    if (window.innerWidth <= this.smallTabletBreak) {
      return;
    }

    this.$refs.sliding.addEventListener('mousedown', this.handleSlideStart);
    this.$refs.sliding.addEventListener('mouseleave', this.handleSlideEnd);
    this.$refs.sliding.addEventListener('mouseup', this.handleSlideEnd);
    this.$refs.sliding.addEventListener('mousemove', this.handleSlideMouseMove);
    this.$refs.sliding.addEventListener('touchend', this.handleSlideEnd, {
      passive: true,
    });
    this.$refs.sliding.addEventListener('touchcancel', this.handleSlideEnd, {
      passive: true,
    });
    this.$refs.sliding.addEventListener('touchmove', this.handleSlideTouchMove, {
      passive: true,
    });
    this.$refs.sliding.addEventListener('touchstart', this.handleSlideTouchStart, {
      passive: true,
    });
  },
  methods: {
    handleSlideStart: function(event) {
      this.isDown = true;
      this.$refs.sliding.classList.add('grabbing');
      this.$refs.sliding.classList.remove('sliding');
      this.$refs.sliding.style.transition = '';
      this.startX = event.pageX;
      this.scrollLeft = this.elementLeftX + this.pos;
    },
    handleSlideMove: function(event) {
      if (!this.isDown) return;
      const x = event.pageX + this.pos;
      if (x - this.startX > 20) return;
      this.move = x - this.startX;
      this.$refs.sliding.style.transform = `translate3d(${this.move}px, 0, 0)`;
      window.requestAnimationFrame(this.translateIfNeccessary);
    },
    handleSlideEnd: function() {
      if (!this.isDown) return;
      this.isDown = false;
      this.$refs.sliding.classList.remove('grabbing');
      this.$refs.sliding.style.transition = this.transition;
      this.pos = this.move;
      setTimeout(() => {
        const classList = [...this.$refs.sliding.classList];
        if (!classList.includes('grabbing')) {
          this.$refs.sliding.classList.add('sliding');
        }
      }, 3000);
    },
    handleSlideMouseMove: function(e) {
      e.preventDefault();
      this.handleSlideMove(e);
    },
    translateGrid: function(translateAmount, index) {
      const yearBreak = this.$refs.gridContainer.getElementsByClassName('year-break')[index];
      const grid = this.$refs.gridContainer.getElementsByClassName('grid')[index];

      yearBreak.style.transform = `translate3d(${translateAmount}px, 0, 0 )`;
      grid.style.transform = `translate3d(${translateAmount}px, 0, 0)`;
    },
    handleSlideTouchMove: function(e) {
      const touch = e.touches[0];
      const y = touch.pageY - window.scrollY;
      const walk = -(y - this.startY) * 0.03;
      window.scrollBy(0, walk);
      this.handleSlideMove(touch);
    },
    handleSlideTouchStart: function(e) {
      const touch = e.touches[0];
      this.startY = touch.pageY - window.scrollY;
      this.handleSlideStart(touch);
    },
    translateIfNeccessary: function() {
      const numberOfSections = 4;
      const simulatedScroll = -this.pos + this.elementLeftX;
      for (let i = 0; i < numberOfSections; i++) {
        const elementWidth = this.gridWidth / numberOfSections;
        const currentTranslate = this.translateCount[i];
        const elementPosition = elementWidth * (i + 1);
        const elementPositionInGrid = this.gridWidth - elementPosition - elementWidth;
        const translateForward = this.gridWidth * currentTranslate.cur - elementPositionInGrid;
        const translateBackward = this.gridWidth * currentTranslate.cur + elementPositionInGrid;

        if (simulatedScroll > translateForward) {
          this.translateGrid(this.gridWidth * currentTranslate.cur, i);
          currentTranslate.cur++;
        } else if (simulatedScroll < translateBackward && currentTranslate.cur > 0) {
          currentTranslate.cur--;
          this.translateGrid(this.gridWidth * currentTranslate.cur, i);
        }
      }
    },
    slidingAnimation: function() {
      if (!(this.$refs && this.$refs.sliding && this.$refs.sliding.classList)) return;
      if (!this.$refs.sliding.classList.contains('sliding')) {
        return;
      } else {
        this.translateIfNeccessary();
        this.pos = this.pos - 8;
        this.$refs.sliding.style.transform = `translate3d(${this.pos}px, 0, 0)`;
      }
    },
    initializeSliding: function() {
      this.elementLeftX = this.$el.getClientRects()[0].left;
      setTimeout(() => {
        this.intervalId = setInterval(() => {
          window.requestAnimationFrame(this.slidingAnimation);
        }, 80);
      }, 100);
    },
    initializeInfiniteScroll: function() {
      setTimeout(() => {
        if (!(this.$refs && this.$refs.gridContainer)) return;
        this.gridWidth = +this.$refs.gridContainer.clientWidth;
        this.transition = `transform 80ms linear`;
        this.$refs.sliding.style.transition = this.transition;
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);

    if (window.innerWidth <= this.smallTabletBreak) {
      return;
    }

    this.$refs.sliding.removeEventListener('mousedown', this.handleSlideStart);
    this.$refs.sliding.removeEventListener('mouseleave', this.handleSlideEnd);
    this.$refs.sliding.removeEventListener('mouseup', this.handleSlideEnd);
    this.$refs.sliding.removeEventListener('mousemove', this.handleSlideMouseMove);
    this.$refs.sliding.removeEventListener('touchend', this.handleSlideEnd);
    this.$refs.sliding.addEventListener('touchcancel', this.handleSlideEnd);
    this.$refs.sliding.addEventListener('touchmove', this.handleSlideTouchMove);
    this.$refs.sliding.addEventListener('touchstart', this.handleSlideTouchStart);
  },
};
</script>
